import { render, staticRenderFns } from "./btnFile.vue?vue&type=template&id=05ca4e88&"
import script from "./btnFile.vue?vue&type=script&lang=js&"
export * from "./btnFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports